export function SearchDataSet(dataSet, values, inc) {
  var filteredData = [];

  dataSet.map(d => {
    var allData = [];

    Object.keys(d).map(c => {
      if (inc.includes(c) && !isEmptyOrSpaces(d[c]) ) {
        var cVals = d[c].toLowerCase().split(" ");
        cVals.map(cval => {
          allData.push(cval.toLowerCase());
          return cval;
        });
      }
      return c;
    });

    var cc = true;
    values.map(v => {
      if (!allData.some(a => a.includes(v.toLowerCase()))) {
        cc = false;
      }
      return v;
    });

    if (cc) {
      filteredData.push(d);
    }

    return d;
  });

  return filteredData;
}

function isEmptyOrSpaces(str) {
  return !str || str === null || str.match(/^ *$/) !== null;
}



// WEBPACK FOOTER //
// ./src/helpers/Search.js